export default "__VITE_ASSET__580ce2ff__"